import React from "react";
import {connect} from "react-redux";
import {Dialog, Button, Typography, TextField, FormControl, Select, MenuItem} from "@material-ui/core";
import {CheckCircle, Cancel} from '@material-ui/icons';
import {IStore} from "../store/reducers";
import actionTypes from "../store/actionTypes";
import axios from "axios";
import {userService} from "../services/UserService";
import config from '../config.json';
import {INotificacion, IParcela, ISections} from "../types";
import copy from 'copy-to-clipboard';
import moment from "moment";


interface IProps {
    opened: boolean
    usuarios: Record<string, Record<string, string|number>[]>
    close(): void
    notify(notification: INotificacion): void
    setUsuarios(usuarios: Record<string, Record<string, string|number>[]>): void
    setPrincipalUsuarios(usuarios: string[]): void
}

interface IState {
    user: string
    pass: string
    error_user: boolean
    error_pass: string
}

class NewUser extends React.Component<IProps, IState>{

    state:IState = {
        user: '',
        pass: '',
        error_user: false,
        error_pass: ''
    }

    handleCreate = () => {
        if (this.state.user === '') {
            this.setState({error_user: true})
            return
        }
        for (const level of Object.keys(this.props.usuarios)) {
            for (const user of this.props.usuarios[level]) {
                if (user.nombre === this.state.user) {
                    this.setState({error_user: true})
                    return
                }
            }
        }

        if (this.state.pass.length < 8) {
            this.setState({error_pass: 'La contraseña debe tener al menos 8 caracteres'})
            return
        }

        axios.post(
            config.url+'/crear/usuario',
            {
                user: this.state.user,
                pass: this.state.pass,
                fecha_creacion: moment(new Date()).format('DD-MM-YYYY')
            },
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                const url: string = config.url+`/get/all/usuarios`
                axios.get(
                    url,
                    {auth: {
                            username: `${userService.getUser()}`,
                            password: `${userService.getPass()}`
                        }})
                    .then((res) => {
                        this.props.close()
                        this.props.notify({message: 'Usuario creado con éxito', variant: 'success'})
                        this.props.setUsuarios(res.data)

                        axios.get(
                            config.url+'/get/usuarios',
                            {auth: {
                                    username: `${userService.getUser()}`,
                                    password: `${userService.getPass()}`
                                }})
                            .then((res: { data: string[] }) => {
                                this.props.setPrincipalUsuarios(res.data)
                            })
                            .catch(() => {})


                    })
                    .catch(() => {alert(`error al solicitar usuarios`)})
            })
            .catch(() => {})
    }


    handleGenerate = () => {
        if (this.state.error_pass !== '') this.setState({error_pass: ''})
        let result = ''
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.,'
        const charactersLength = characters.length
        for (let i = 0; i < 8; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
        }
        this.setState({pass: result})
    }

    render() {
        return (
            <Dialog
                open={this.props.opened}
                onClose={() => this.props.close()}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: "center",
                        overflow: "hidden"
                    }
                }}
                maxWidth={"lg"}
            >

                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <TextField
                    error={this.state.error_user}
                    label={this.state.error_user? 'Error: nombre no disponible' : 'Nombre de usuario'}
                    style={{width: 300, margin: 20}}
                    variant="outlined"
                    value={this.state.user}
                    onChange={e => {
                        if (this.state.error_user) this.setState({error_user: false})
                        this.setState({user: e.target.value})
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        margin: 20,
                        marginTop: 0
                    }}
                >
                    <TextField
                        error={this.state.error_pass !== ''}
                        label={this.state.error_pass !== ''? this.state.error_pass : 'Contraseña'}
                        style={{width: 300}}
                        variant="outlined"
                        value={this.state.pass}
                        onChange={e => {
                            if (this.state.error_pass !== '') this.setState({error_pass: ''})
                            this.setState({pass: e.target.value})
                        }}
                    />
                    <Button
                        color={"primary"}
                        onClick={() => copy(this.state.pass)}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            Copiar
                        </Typography>
                    </Button>

                    <Button
                        color={"primary"}
                        onClick={() => this.handleGenerate()}
                    >
                        <Typography
                            style={{
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                color: "#4C494B"
                            }}
                        >
                            Generar
                        </Typography>
                    </Button>
                </div>

                <Button
                    variant={"contained"}
                    color={"primary"}
                    style={{
                        margin: 20,
                        marginTop: 0
                    }}
                    onClick={() => this.handleCreate()}
                >
                    <Typography
                        style={{
                            fontWeight: "bold",
                            fontFamily: "Poppins",
                            color: "#4C494B"
                        }}
                    >
                        crear usuario
                    </Typography>
                </Button>


            </Dialog>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    opened: state.navegacion.dialogs.new_user,
    usuarios: state.gestionUsuarios.usuarios
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    close: () => dispatch({type: "open-new-user-dialog", callback:false}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setUsuarios: (usuarios: Record<string, Record<string, string|number>[]>) => dispatch({type: "set-control-usuarios-usuarios", usuarios}),
    setPrincipalUsuarios: (usuarios: string[]) => dispatch({type: "set-principal-usuarios", usuarios})
});

export default connect(mapStateToProps, mapDispatchToProps)(NewUser);
